import { useEffect, useMemo, useState } from "react";
import faqData from "../../data/faqData";
import "./FAQ.css";

const FAQ = ({ language = "DE", useAccordion = true }) => {
  const content = useMemo(() => faqData[language] || faqData.DE, [language]);
  const [openIndexes, setOpenIndexes] = useState(() =>
    useAccordion ? [0] : content.items.map((_, idx) => idx)
  );

  useEffect(() => {
    setOpenIndexes(useAccordion ? [0] : content.items.map((_, idx) => idx));
  }, [content, useAccordion]);

  const isOpen = (index) => openIndexes.includes(index);

  const toggleIndex = (index) => {
    if (!useAccordion) return;
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <section className="faq-wrapper" aria-label="FAQ Section">
      {/* <h2 className="faq-title">{content.title}</h2> */}

      {content.items.map((item, index) => (
        <article className="faq-item" key={`${item.question}-${index}`}>
          {useAccordion ? (
            <button
              type="button"
              className="faq-question-btn"
              onClick={() => toggleIndex(index)}
              aria-expanded={isOpen(index)}
              aria-controls={`faq-answer-${index}`}
              id={`faq-question-${index}`}
            >
              {item.question}
            </button>
          ) : (
            <h3 className="faq-question-static" id={`faq-question-${index}`}>
              {item.question}
            </h3>
          )}

          {isOpen(index) && (
            <div
              className="faq-answer"
              id={`faq-answer-${index}`}
              aria-labelledby={`faq-question-${index}`}
            >
              {item.paragraphs?.map((paragraph, pIndex) => {
                const isLabel = paragraph === "Sponsoren:" || paragraph === "Vereine und Sportler:" || paragraph === "Sponsors:" || paragraph === "Clubs and athletes:";
                return isLabel ? (
                  <p key={`p-${pIndex}`}>
                    <strong>{paragraph}</strong>
                  </p>
                ) : (
                  <p key={`p-${pIndex}`}>{paragraph}</p>
                );
              })}

              {item.links?.map((link, lIndex) => (
                <p key={`l-${lIndex}`}>
                  <a className="faq-link" href={link.href}>
                    {link.label}
                  </a>
                </p>
              ))}

              {item.list?.length ? (
                <ul>
                  {item.list.map((entry, listIndex) => (
                    <li key={`li-${listIndex}`}>{entry}</li>
                  ))}
                </ul>
              ) : null}

              {item.tailParagraphs?.map((paragraph, tIndex) => (
                <p key={`t-${tIndex}`}>{paragraph}</p>
              ))}

              {item.email ? (
                <p>
                  <a className="faq-link" href={`mailto:${item.email}`}>
                    {item.email}
                  </a>
                </p>
              ) : null}
            </div>
          )}
        </article>
      ))}
    </section>
  );
};

export default FAQ;
